// External Imports
import get from 'lodash/fp/get.js';
import set from 'lodash/fp/set.js';
import { createSelector } from 'reselect';
import { compile } from 'path-to-regexp';

// Internal Imports
import { getActivePagination } from './getActivePagination.mjs';
import { getContentArchiveItems } from './getContentArchive.mjs';
import { getPathMap } from './getPathMap.mjs';
import { getMatch } from './getMatch.mjs';

// Local Functions
const getLandingPageItem = createSelector(
  [get('landingPage'), get('contentItem.landing-page.byId')],
  (landingPageId, landingPagesById) =>
    landingPagesById ? landingPagesById[landingPageId] : undefined,
);

/**
 * Selector that will return a landing page entity
 *
 * @param {string} type landing page type
 * @return {function}   selector function
 */
const getLandingPage = createSelector(
  [getLandingPageItem, getActivePagination, getPathMap, getContentArchiveItems, getMatch],
  (landingPage, pagination, pathMap, relatedItems, { pathType, params }) => {
    if (!landingPage) {
      return;
    }
    const landingPageToPath = compile(pathMap[pathType]);
    const { totalPages, currentPage } = pagination;

    // eslint-disable-next-line consistent-return -- optional return
    return {
      item: set('path', landingPageToPath({ ...params }), landingPage),
      pagination: set(
        'hasMore',
        totalPages ? totalPages > 1 && currentPage < totalPages : false,
        pagination,
      ),
      relatedItems,
    };
  },
);

// Module Exports
export { getLandingPage };
